import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  DnmRoleMappingIProps,
  SaveDnmRoleMappingsIProps,
} from "~/entity/DnmRoleMappings/model/schema";

const dnmRoleMappingsServiceMap: Record<string, string> = {
  roleMappings: "/dealer/dnm-role-mappings",
};

export class DnmRoleMappingsService {
  static GET = {
    getRoleMappings: (): NetworkResponse<DnmRoleMappingIProps[] | []> =>
      requestREST.get(dnmRoleMappingsServiceMap.roleMappings),
  };
  static PUT = {
    saveRoleMappings: (
      data: SaveDnmRoleMappingsIProps,
    ): NetworkResponse<DnmRoleMappingIProps[]> =>
      requestREST.put(dnmRoleMappingsServiceMap.roleMappings, data),
  };
  static DELETE = {
    deleteRoleMapping: (id: number): NetworkResponse<void> =>
      requestREST.delete(`${dnmRoleMappingsServiceMap.roleMappings}/${id}`),
  };
}
